import React, { useEffect, useRef } from 'react';

export const TypeSignature = ({ typedName, onNameChange }) => {
    const scrollRef = useRef(null);

    useEffect(() => {
        const el = scrollRef.current;
        if (el) el.scrollTop = el.scrollHeight;
    }, [typedName]);

    return (
        <>
            <input
                type="text"
                className="signature-request-type-input"
                placeholder="Enter your name"
                value={typedName}
                onChange={(e) => onNameChange(e.target.value)}
            />

            <div className="signature-request-canvas-box">
                <div className="signature-request-typed-scroll" ref={scrollRef}>
                    <p className="signature-request-typed-preview">{typedName}</p>
                </div>
                <div className="signature-request-canvas-line" />
            </div>

            <div className="signature-request-draw-actions">
                <button type="button" className="signature-request-clear-btn" disabled={!typedName} onClick={() => onNameChange('')}>
                    Clear
                </button>
            </div>
        </>
    );
};
